import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listUser } from '../../redux/slices/user.slice';
import { listTache, createTache, updateTache, deleteTache } from '../../redux/slices/tache.slice';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';

const typeTaches = [
  { value: 'cmd-a-valider', label: 'Commande A Valider', color: '#FFB84D' },
  { value: 'cmd-a-valider-cq', label: 'Commande A Valider Cq', color: '#FF8C00' },
  { value: 'cmd-a-saisir', label: 'Commande A Saisir', color: '#4CAF50' },
  { value: 'cmd-a-ettiqueter', label: 'Commande A Ettiqueter', color: '#00BCD4' },
  { value: 'cmd-a-envoyer', label: 'Commande A Envoyer', color: '#2196F3' },
  { value: 'cmd-a-receptionner', label: 'Commande A Receptionner', color: '#673AB7' },
  { value: 'cmd-a-livrer', label: 'Commande A Livrer', color: '#F44336' },
  { value: 'cmd-a-resoudre', label: 'Commande A Resoudre', color: '#9C27B0' },
  { value: 'autre', label: 'Autre', color: '#B0BEC5' },
];

const tacheStatus = {
  EN_ATTENTE: 'en-attente',
  EN_COURS: 'en-cours',
  TRAITE: 'traite',
  ANNULE: 'annule',
};

const BCrumb = [
  { to: '/app', title: 'Home' },
  { title: 'Tâches' },
];

const TacheListContainer = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.tache_store);
  const [lst_user, set_lst_user] = useState([]);
  const [lst_tache, set_lst_tache] = useState([]);
  const [sel_tache, set_sel_tache] = useState(null);
  const [show_form, set_show_form] = useState(false);

  const { sel_sw_mg } = useSelector((state) => state.ui_store);
   const { loggedUser } = useSelector((state) => state.auth_store);
  useEffect(() => {
    load_data();
  }, [sel_sw_mg]);

  const load_users = () => {
    dispatch(listUser())
      .unwrap()
      .then((res) => {
        set_lst_user(Array.isArray(res) ? res : []);
      });
  };

  const load_data = () => {
    dispatch(listTache())
      .unwrap()
      .then((res) => {
        set_lst_tache(Array.isArray(res) ? res : []);
      });
  };

  const onCreateTache = (data) => {
    try {
      if (data)
        dispatch(createTache({...data, createdBy : loggedUser ? `${loggedUser?.nom} ${loggedUser?.prenom}` : ''}))
          .unwrap()
          .then(() => {
            set_show_form(false);
            load_data();
          });
    } catch (error) {
      console.log(error);
    }
  };
  const onUpdateTache = (data) => {
    try {
      if (data)
        dispatch(updateTache(data))
          .unwrap()
          .then(() => {
            set_show_form(false);
            load_data();
          });
    } catch (error) {
      console.log(error);
    }
  };
  const onDeleteTache = (id) => {
    try {
      if (id)
        dispatch(deleteTache(id))
          .unwrap()
          .then(() => {
            load_data();
          });
    } catch (error) {
      console.log(error);
    }
  };

  const onShowForm = (data) => {
    set_sel_tache(data);
    set_show_form(true);
  };
  const onCloseForm = () => {
    set_sel_tache(null);
    set_show_form(false);
  };

  useEffect(() => {
    load_users();
    load_data();
  }, []);

  return (
    <PageContainer title="Les Tâches" description="">
      <Breadcrumb title="Les Tâches" items={BCrumb} />

      <TacheList
        lst_tache={lst_tache}
        lst_user={lst_user}
        onShowForm={onShowForm}
        loading={loading}
        error={error}
        onUpdateTache={onUpdateTache}
        onDeleteTache={onDeleteTache}
      />

      <TacheForm
        show={show_form}
        onClose={onCloseForm}
        lst_user={lst_user}
        onCreateTache={onCreateTache}
        onUpdateTache={onUpdateTache}
        sel_tache={sel_tache}
        loading={loading}
        error={error}
        sel_sw_mg={sel_sw_mg}
      />
    </PageContainer>
  );
};

const TacheForm = ({
  show,
  onClose,
  sel_tache,
  onCreateTache,
  onUpdateTache,
  lst_user,
  loading,
  error,
  sel_sw_mg
}) => {
  const [form_values, set_form_values] = useState({
    users: [],
    description: '',
    type: 'autre',
    is_urgent: false,
    date_urgent: '',
  });

  const [field_keys, set_field_keys] = useState({
    users: `select-users-${Date.now()}`,
    type: `select-type-${Date.now()}`,
  });

  useEffect(() => {
    if (sel_tache) {
      set_form_values({
        users: Array.isArray(sel_tache?.users) ? sel_tache.users : [],
        description: sel_tache?.description,
        type: sel_tache?.type,
        is_urgent: sel_tache?.is_urgent,
        date_urgent: sel_tache?.date_urgent,
      });
    } else
      set_form_values({
        users: [],
        description: '',
        type: 'autre',
        is_urgent: false,
        date_urgent: '',
      });

    set_field_keys({
      users: `select-users-${Date.now()}`,
      type: `select-type-${Date.now()}`,
    });
  }, [sel_tache]);

  const onSubmit = () => {
    if (sel_tache) {
      let tmp = { ...form_values, idTache: sel_tache?.idTache };
      onUpdateTache(tmp);
    } else {
      // use the first assigned user's magasin, same assumption as before
      onCreateTache({ ...form_values, magasin: sel_sw_mg });
    }
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 500 } }}
      maxWidth="xs"
      open={show}
    >
      <DialogTitle>
        <Typography variant="h5" color={'primary.main'}>
          Nouvelle Tâche
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        {error && (
          <Alert variant="filled" severity="error" sx={{ my: 1 }}>
            {error}
          </Alert>
        )}
        <Grid container spacing={1}>
          <Grid item lg={12} xs={12}>
            <Typography>Utilisateurs</Typography>
            <Autocomplete
              multiple
              disabled={loading}
              fullWidth
              id="filter-users"
              key={field_keys.users}
              options={!lst_user ? [] : lst_user}
              value={form_values?.users || []}
              isOptionEqualToValue={(option, value) => option?.idUser === value?.idUser}
              getOptionLabel={(el) => `${el?.nom} ${el?.prenom} (${el?.email})`}
              onChange={(event, newValue) => {
                set_form_values({ ...form_values, users: newValue });
              }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    size="small"
                    label={`${option?.nom} ${option?.prenom}`}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Nom/Prénom/Email ..."
                  error={!form_values?.users?.length}
                />
              )}
            />
          </Grid>
          <Grid item lg={12} xs={12}>
            <Typography variant="subtitle2" fontWeight={500}>
              Type de tâche
            </Typography>

            <Autocomplete
              fullWidth
              id="filter-type-tache"
              key={field_keys.type}
              loading={loading}
              options={!typeTaches ? [] : typeTaches}
              value={typeTaches.find((t) => t.value === form_values?.type) || null}
              getOptionLabel={(el) => `${el?.label}`}
              onChange={(event, newValue) => {
                set_form_values({ ...form_values, type: newValue?.value });
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" placeholder={''} error={!form_values?.type} />
              )}
            />
          </Grid>
          <Grid item lg={12} xs={12}>
            <Typography>Description</Typography>
            <TextField
              disabled={loading}
              size="small"
              fullWidth
              type="text"
              value={form_values?.description}
              onChange={(e) => set_form_values({ ...form_values, description: e?.target?.value })}
            />
          </Grid>

          <Grid item lg={4} xs={4}>
            <Typography variant="subtitle2">Urgent</Typography>
            <Switch
              size="small"
              checked={form_values.is_urgent}
              onChange={(e) => set_form_values({ ...form_values, is_urgent: e?.target?.checked })}
            />
          </Grid>

          {form_values?.is_urgent && (
            <Grid item lg={8} xs={8}>
              <Typography>Date Urgent</Typography>
              <TextField
                disabled={loading}
                size="small"
                fullWidth
                type="date"
                value={form_values?.date_urgent}
                onChange={(e) => set_form_values({ ...form_values, date_urgent: e?.target?.value })}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          color="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Fermer
        </Button>
        <Button variant="contained" color="success" onClick={onSubmit} disabled={loading}>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const TacheList = ({
  lst_tache,
  loading,
  error,
  lst_user,
  onShowForm,
  onUpdateTache,
  onDeleteTache,
}) => {
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    user: null,
    status: '',
    type: '',
    isUrgent: false,
  });

  const applyFilters = (newFilters) => {
    const filtered = lst_tache.filter((item) => {
      const users = Array.isArray(item.users) ? item.users : [];
      return (
        (newFilters.user
          ? users.some((u) => u.idUser === newFilters.user?.idUser)
          : true) &&
        (newFilters.status ? item.status === newFilters.status : true) &&
        (newFilters.type ? item.type === newFilters.type : true) &&
        (newFilters.isUrgent !== false ? item.is_urgent === newFilters.isUrgent : true)
      );
    });
    setFilteredData(filtered);
  };

  const handleFilterChange = (e, filterType) => {
    const newFilters = { ...filters, [filterType]: e?.target?.value ?? null };
    setFilters(newFilters);
    applyFilters(newFilters);
  };

  const handleUrgentFilterChange = (e) => {
    const newFilters = { ...filters, isUrgent: e.target.checked };
    setFilters(newFilters);
    applyFilters(newFilters);
  };

  useEffect(() => {
    setFilteredData(lst_tache);
  }, [lst_tache]);

  return (
    <div>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            value={filters.user}
            onChange={(e, newValue) => handleFilterChange({ target: { value: newValue } }, 'user')}
            options={lst_user}
            isOptionEqualToValue={(option, value) => option?.idUser === value?.idUser}
            getOptionLabel={(option) => `${option?.nom} ${option?.prenom}`}
            renderInput={(params) => <TextField {...params} label="User" />}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={filters.status}
              onChange={(e) => handleFilterChange(e, 'status')}
              label="Status"
            >
              {Object.values(tacheStatus).map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Type</InputLabel>
            <Select
              value={filters.type}
              onChange={(e) => handleFilterChange(e, 'type')}
              label="Type"
            >
              {Object.values(typeTaches).map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={<Checkbox checked={filters.isUrgent} onChange={handleUrgentFilterChange} />}
            label="Urgent"
          />
        </Grid>
      </Grid>

      <Box textAlign={'end'}>
        <Button onClick={() => onShowForm(null)} variant="outlined" color="success">
          Nouvelle Tâche
        </Button>
      </Box>

      <TableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Users</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Urgent</TableCell>
              <TableCell>Date urgent</TableCell>
              <TableCell>Crée le</TableCell>
              <TableCell>Crée par</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((tache) => (
              <TableRow key={tache.idTache}>
                <TableCell>
                  <Chip
                    size="small"
                    label={typeTaches?.find((type) => type.value === tache.type)?.label}
                    sx={{
                      backgroundColor: typeTaches?.find((type) => type.value === tache.type)?.color,
                      textTransform: 'capitalize',
                      borderRadius: 1,
                      color: 'white',
                    }}
                  />
                </TableCell>
                <TableCell sx={{ color: 'primary.main', fontWeight: 500 }}>
                  <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {(Array.isArray(tache.users) ? tache.users : []).map((u) => (
                      <Chip
                        key={u.idUser}
                        size="small"
                        label={`${u.nom} ${u.prenom}`}
                        variant="outlined"
                      />
                    ))}
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={tache.status}
                    color={
                      tache.status === 'traite'
                        ? 'success'
                        : tache.status === 'en-cours'
                        ? 'primary'
                        : 'warning'
                    }
                    sx={{
                      textTransform: 'capitalize',
                      borderRadius: 1,
                      color: 'white',
                    }}
                  />
                </TableCell>
                <TableCell>{tache.description}</TableCell>
                <TableCell>{tache.is_urgent ? 'Oui' : 'Non'}</TableCell>
                <TableCell>{tache.date_urgent ? tache.date_urgent : 'N/A'}</TableCell>
                <TableCell>{String(tache.created_at).substring(0,10)}</TableCell>
                <TableCell>{tache.createdBy ?? '---'}</TableCell>
                <TableCell>
                  {tache.status === 'en-attente' && (
                    <Button
                      size="small"
                      onClick={() => onUpdateTache({ idTache: tache?.idTache, status: 'en-cours' })}
                      variant="outlined"
                      color="primary"
                    >
                      Mettre en cours
                    </Button>
                  )}
                  {tache.status === 'en-cours' && (
                    <Button
                      size="small"
                      onClick={() => onUpdateTache({ idTache: tache?.idTache, status: 'traite' })}
                      variant="outlined"
                      color="success"
                      sx={{ ml: 1 }}
                    >
                      Mettre traité
                    </Button>
                  )}
                  <Button
                    size="small"
                    onClick={() => onShowForm(tache)}
                    variant="outlined"
                    color="secondary"
                    sx={{ ml: 1 }}
                  >
                    Modifier
                  </Button>
                  <Button
                    size="small"
                    onClick={() => onDeleteTache(tache?.idTache)}
                    variant="outlined"
                    color="error"
                    sx={{ ml: 1 }}
                  >
                    Annuler
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TacheListContainer;